/**
 * phpでページに吐き出された全アイテムを管理
 */
import { AxeItem, RegularItemKbn } from '@/types/AxeItem'
import Vue from 'vue'


class _axeItems {
  private get _items() {
    // console.log('window.axeItems:' + JSON.stringify(window.axeItems))
    return window.axeItems || []
  }

  get all() {
    return this._items
  }

  getItem(item: { itemId: number | string; itemDetailId: number | string }): AxeItem {
    return this._items.find(
      ({ itemDetailId, itemId }) => item.itemDetailId == itemDetailId && item.itemId == itemId
    )
  }
  getItemByItemDetailId(itemDetailId: number | string): AxeItem {
    return this._items.find((item) => item.itemDetailId == itemDetailId)
  }
  getItemByItemId(itemId: Number | String): AxeItem {
    return this._items.find((item) => item.itemId == itemId)
  }
  // getRegularItemByNormalItemDetailId(normalItemDetailId: number | string): AxeItem {
  //   const normalItem = this.getItemByItemDetailId(normalItemDetailId)
  //   return this._items.find(
  //     (item) =>
  //       item.regularItemKbn === RegularItemKbn.Regular &&
  //       item.itemId !== normalItem.itemId &&
  //       item.itemPageUrl === normalItem.itemPageUrl
  //   )
  // }
  getNormalItemByRegularItemDetailId(regularItemDetailId: number | string): AxeItem {
    return this._items.find((i) =>
      i.regularItemDetailId['1'] === regularItemDetailId ||
      i.regularItemDetailId['2'] === regularItemDetailId ||
      i.regularItemDetailId['3'] === regularItemDetailId
    )
  }
  getThumbnailImagePathWithItemCd(itemCd): string {
    return (this._items.filter((i) => i.itemCd == itemCd).find((i) => i.itemPageThumbnailImage) || {})
      .itemPageThumbnailImage
  }
  getThumbnailImagePathWithItemId(itemId): string {
    return this.getThumbnailImagePathWithItemCd((this.getItemByItemId(itemId) || {}).itemCd)
  }

  isItemExistByItemId(itemId: Number | string): boolean {
    if (this._items.findIndex((item) => item.itemId == itemId) >= 0){
      return true;
    } else {
      return false;
    }
  }
  getReqularItems(regularCourseCd: Number = 1): AxeItem[] {
    let regularItemDetailIds = []
    let regularItems = []

    this._items.forEach( item => {
      if(item.regularItemDetailId['' + regularCourseCd] !== ''){
        regularItemDetailIds.push(item.regularItemDetailId['' + regularCourseCd])
      }
    })
    regularItemDetailIds.forEach(id => {
      regularItems.push(
        this._items.find((i) => i.itemDetailId == id)
      )
    })
    return regularItems
  }
  getRegularItemByChangedRegularCourseCd(regularItemDetailCd: string, changedRegularCourseCd: number): AxeItem {
    const NomalItem = this.getNormalItemByRegularItemDetailId(regularItemDetailCd)
    const targetItemDetailId = NomalItem.regularItemDetailId[changedRegularCourseCd]
    return this.getItemByItemDetailId(targetItemDetailId)
  }
}

export const AxeItems = new _axeItems()
export const $AxeItems = Vue.observable(new _axeItems())
